import { NgModule } from "@angular/core";
import { MyAccountComponent } from "./components/my-account/my-account.component";
import { CoreModule } from "../core/core.module";

const modules = [CoreModule];

const components = [MyAccountComponent];

@NgModule({
	imports: [...modules],
	declarations: [...components],
	exports: [...modules, ...components]
})
export class AccountModule {}
